import React, { useEffect, useState, useRef } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
// import validation from "./validation";
import { getValidationSchema } from "./validation";
import { yupResolver } from "@hookform/resolvers/yup";
import services from "../../API/services";
import { useDispatch, useSelector } from "react-redux";
import ImageUploadBox from "../../components/imageUploadBox";
import { useParams, useLocation } from "react-router-dom";
import { InputField } from "../../components/InputField/InputField";
import { arrayColumn, isJsonString } from "../../utils/utils";
import { baseImgUrl } from "../../API/client/api";
import { toast } from "react-toastify";
import Slider from "react-slick";
import { useCallback } from "react";
import { useMemo } from "react";
import { propertyPolicy } from "constant/constants";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { Margin, usePDF } from "react-to-pdf";
import { MdOutlineModeEdit } from "react-icons/md";
import { FaRegTrashAlt } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { OwnerShipModal } from "./OwnerShipModal";

const ADULT_CHILD_RADIO_GROUP = [
  { label: "1x", value: 1 },
  { label: "2x", value: 2 },
  { label: "3x", value: 3 },
  { label: "4x", value: 4 },
  { label: "5x", value: 5 },
];

const Property = () => {
  const { sliderImgOnly, AlertIcon, homeIcon } = Imagesdata || {};
  const dispatch = useDispatch();
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [imageSet, setImageSet] = useState([]);
  const [propertyData, setPropertyData] = useState({});
  const { userDetail } = useSelector(authenticationSeletor);

  const data = location?.state

  const clickedButtonRef = useRef("");

  const validationSchema = useMemo(
    () => getValidationSchema(propertyData),
    [propertyData]
  );

  // const {
  //   register,
  //   handleSubmit,
  //   reset,
  //   setValue,
  //   watch,
  //   formState: { errors },
  // } = useForm({ ...validation, mode: "onSubmit" });



  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    mode: "onSubmit",
  });

  const { threeHrPrice, sixHrPrice, nineHrPrice } = watch();

  const {
    register: registerCreateRoom,
    handleSubmit: handleSubmitCreateRoom,
    formState: { errors: errorsCreate },
  } = useForm();

  const {
    register: registerEditRoom,
    handleSubmit: handleSubmitEditRoom,
    reset: resetEditRoomForm,
    getValues,
    formState: { errors: errorsRoom },
  } = useForm();

  const [imageData, setImageData] = useState([]);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [categoryData, setCategoryData] = useState([]);
  const [addedRoomDetails, setAddedRDetails] = useState([]);
  const [roomDetails, setRoomDetails] = useState({
    floorNumber: "",
    roomNumber: "",
    occupancy: 1,
  });
  const [categoryPropertyData, setCategoryPropertyData] = useState([]);
  const [selectedAminites, setselectedAminites] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [showImagesPopup, setShowImagesPopup] = useState(false);
  const [imgFilter, setImgFilter] = useState(0);
  const [showImages, setShowImages] = useState([]);
  const [rejectModal, setRejectModal] = useState(false);
  const [reason, setReason] = useState("");
  const [showPolicy, setShowPolicy] = useState([]);
  const [bankDetails, setBankDetails] = useState({});
  const [fillText, setFillText] = useState(0);
  const [propertyLogs, setPropertyLogs] = useState([]);
  const [showLogs, setShowLogs] = useState(false);
  const [showApprovalPopup, setShowApprovalPopup] = useState(false);

  const [showOwnerModal, setShowOwnerModal] = useState(false);


  const params = useParams();
  useEffect(() => {
    getPropertyDetail(params.id);
  }, []);

  const { roomDescription, category } = watch();
  // useEffect(() => {
  //   setFillText(roomDescription?.length);
  // }, [roomDescription]);

  useEffect(() => {
    let text = categoryData?.find((item) => item.id == category)?.description
    setValue("roomDescription", text)
  }, [category])

  useEffect(() => {
    getAmenities();
    getRoomCategory();
  }, []);

  const [profileImg, setProfileImg] = useState(0);
  const [activeImageState, setActiveImageState] = useState(false);

  const getAmenities = async () => {
    try {
      const res = await services.property.getAmenitiesService();
      if (res.status === 200) {
        setAmenitiesData(res?.data?.data);
      }
    } catch (error) { }
  };
  const getRoomCategory = async () => {
    try {
      const res = await services.property.getRoomCategoryService();
      if (res.status === 200) {
        setCategoryData(res?.data?.data);
      }
    } catch (error) { }
  };

  const changeHeroImg = async () => {
    try {
      const res = await services.property.updatePropertyProfile(
        selectedData?.id,
        { profileImageID: profileImg }
      );

      if (res.status === 200) {
        // onHide();
      }
    } catch (error) { }
  };

  const getPropertyDetail = async (id) => {
    try {
      const res = await services.property.getPropertyCategoryServiceId(id);
      if (res.status === 200) {
        setPropertyData(res?.data?.data);
        let filteredDataSet = res?.data?.data?.Rooms?.find((item) => item.id == selectedCategory.id)
        setSelectedCategory(filteredDataSet)
        let policy = [res?.data?.data.bookingPolicy];
        if (isJsonString(res?.data?.data.bookingPolicy)) {
          policy = JSON.parse(res?.data?.data.bookingPolicy);
        }
        if (policy) {
          setShowPolicy(policy);
        }
        if (res?.data?.data?.bankDetails) {
          let bankData = {};
          res?.data?.data?.bankDetails?.split("~").map((item, index) => {
            if (index === 0) {
              bankData.BankName = item;
            }
            if (index === 1) {
              bankData.BranchName = item;
            }
            if (index === 2) {
              bankData.BankHolder = item;
            }
            if (index === 3) {
              bankData.BankAccountNumber = item;
            }
            if (index === 4) {
              bankData.BankIFSCCode = item;
            }
          });
          setBankDetails(bankData);
        }
      }
    } catch (error) { }
  };


  const onPopupHide = () => {
    setEditMode(false);
    setShow(false);
    reset();
    setImageData([]);
    setSelectedData({});
    setAddedRDetails([]);
    setImageSet([]);
    setselectedAminites([]);
    setValue('threeHrPrice', '')
    setValue('sixHrPrice', '')
    setValue('nineHrPrice', '')
  }


  const onSubmit = async (payload) => {
    var bodyFormData = new FormData();
    bodyFormData.append("categoryId", payload.category);
    bodyFormData.append("roomDescription", payload.roomDescription);
    bodyFormData.append("status", 0);
    bodyFormData.append("propertyId", propertyData.id);
    bodyFormData.append("regularPrice", payload.regularPrice);
    if (category == 1 && propertyData?.allowHourly) {
      bodyFormData.append("threeHrPrice", payload.threeHrPrice);
      bodyFormData.append("sixHrPrice", payload.sixHrPrice);
      bodyFormData.append("nineHrPrice", payload.nineHrPrice);
    }
    if (profileImg && activeImageState) {
      bodyFormData.append("heroImage", profileImg);
    }
    for (let i = 0; i < payload.amenities.length; i++) {
      bodyFormData.append(`amenities[${i}]`, payload.amenities[i]);
    }
    if (imageData?.length + imageSet?.length > 0) {
      imageData.map((dataImg) => {
        bodyFormData.append("images", dataImg);
      });
    } else {
      toast.error("Please Select Images*", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    try {
      let res = {};
      if (editMode) {
        let editPayload = {
          id: selectedData.id,
          body: bodyFormData,
        };
        res = await services.property.updateRRoomService(editPayload);
        createPropertyActionLogs('Room Modified', propertyData?.id)
      } else {
        res = await services.property.createRRoomService(bodyFormData);
        createPropertyActionLogs('Room Created', propertyData?.id)
      }

      if (res.status === 200) {
        onPopupHide()
        if (editMode) {
          toast.success("Room Updated SuccessFull !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        } else {
          toast.success("Room Created SuccessFull !", {
            autoClose: 1000,
            pauseOnHover: true,
            position: "top-right",
          });
        }
      } else {
        toast.error("Some Error Occured*", {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
      }
    } catch (error) { }
    finally {
      getPropertyDetail(params.id);
    }
  };

  useEffect(() => {
    getPropertyDetail(params.id);
  }, [params.id])

  const imageHandler = (data) => {
    setImageData((preValue) => {
      return [...preValue, data];
    });
  };

  useEffect(() => {
    getPropertyCategory();
  }, []);

  const getPropertyCategory = async () => {
    try {
      const res = await services.property.getPropertyCategoryService();
      if (res.status === 200) {
        setCategoryPropertyData(res?.data?.data);
      }
    } catch (error) { }
  };

  const amenitiesRender = (dataType, dataset) => {
    let selectedAminits = [];
    amenitiesData?.map((data) => {
      propertyData.PropertyAmenities?.filter((innerData) => {
        if (innerData.propertyAmenitiesId === data.id) {
          selectedAminits.push(data);
        }
      });
    });
    return selectedAminits;
  };

  const addHandler = () => {
    if (
      roomDetails.floorNumber &&
      roomDetails.roomNumber &&
      roomDetails.occupancy
    ) {
      setAddedRDetails([...addedRoomDetails, roomDetails]);
    } else {
      toast.error("Please Enter Floor and Room Number!", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
    }
  };

  const isBookHotel = location?.pathname.includes("book-hotel");

  const editHandler = (data) => {
    setSelectedData(data);
    setShow(true);
    setEditMode(true);
    setValue("category", data.categoryId);
    setValue("regularPrice", data.regularPrice);
    setValue("threeHrPrice", data.threeHrPrice);
    setValue("sixHrPrice", data.sixHrPrice);
    setValue("nineHrPrice", data.nineHrPrice);
    setValue("roomDescription", data.roomDescription);
    setValue("amenities", arrayColumn(data.RoomAmenities, "amenitiesId"));
    setselectedAminites(arrayColumn(data.RoomAmenities, "amenitiesId"));
    let tempObj = [];
    data.RoomDetails.map((data) => {
      let obj = {
        floorNumber: data.floorNumber,
        roomNumber: data.roomNumber,
        occupancy: data?.occupancy?.toString(),
      };
      tempObj.push(obj);
    });
    setAddedRDetails(tempObj);
    let imagData = [];
    data?.RoomImages.map((data) => {
      let obj = {
        id: data.id,
        filename: data.imageName,
        filetype: "",
        fileimage: `${baseImgUrl}/${data.imageName}`,
        datetime: "",
        filesize: "",
      };
      imagData.push(obj);
    });
    setImageSet(imagData);
  };

  const changeHandler = (e, data) => {
    if (e.target.checked) {
      setselectedAminites([...selectedAminites, Number(e.target.value)]);
    } else {
      const resultfilter = selectedAminites.filter((d, index) => {
        return d !== Number(e.target.value);
      });
      setselectedAminites(resultfilter);
    }
  };

  const removeRoomHandler = (i) => {
    let getRooms = [...addedRoomDetails];
    getRooms.splice(i, 1);
    setAddedRDetails(getRooms);
  };

  const deleteImageHandler = async (id) => {
    try {
      const res = await services.property.deleteRoomImageService(id);
      if (res.status === 200) {
        getPropertyDetail(params.id);
      }
    } catch (error) { }
  };

  const changeStatus = async (approved) => {
    try {
      let message = "";
      const bodyData = {
        approved,
        id: propertyData?.id,
        approvedBy: userDetail.id,
      };
      if (propertyData.onboarded_date === null) {
        bodyData.onboarded_date = new Date()
      }
      if (approved === 1) {
        message = "Property Approved SuccessFull !";
      } else {
        // bodyData.remarks = propertyData?.remarkForCancellation + ',' + reason;
        // bodyData.remarks = reason;
        message = "Property Rejected SuccessFull !";
      }
      const res = await services.property.changePropertyStatus(bodyData)
      if (res.status === 200) {
        toast.success(message, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        getPropertyDetail(params.id);
        setRejectModal(false);
      }
    } catch (error) { }
  };

  const settingsImgSlider = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    adaptiveHeight: true,
  };

  const imageFilterFun = (filter) => {
    const img = propertyData?.PropertyImage?.filter((i) => {
      if (filter) {
        return i.title === filter || i.title === filter.charAt(0);
      } else if (filter === 0) {
        return i;
      }
    });
    setShowImages(() =>
      img?.length > 0
        ? img
        : [
          {
            title: "all",
            image: "",
          },
        ]
    );
  };

  const imgCategoryFilter = useCallback(
    (filter) => {
      setImgFilter(filter);
    },
    [imgFilter, propertyData]
  );

  useMemo(() => {
    imageFilterFun(imgFilter);
  }, [imgFilter, propertyData]);

  const rejectWithReason = async (e) => {
    e.preventDefault();
    if (!reason.length) {
      toast.error("Enter Reason for Reject Property !", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    else if (rejectReason.length == 0) {
      toast.error("Please Select Reason for Reject Property !", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    await changeStatus(2);
    createPropertyActionLogs(`Property Reject - ${rejectReason}`, propertyData?.id);
  };

  const createPropertyActionLogs = async (action, id) => {
    try {
      const payload = {
        propertyId: id,
        action: `${action}`,
        actionBy: userDetail.id,
        remark: reason,
        data: {
          id: userDetail.id,
          name: userDetail.firstName,
        }
      }
      const res = await services.property.propertyActionLogsService(payload)
      if (res.data.status === true) {
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const fetchPropertyActionLogs = async (id) => {
    setShowLogs(true)
    try {
      const res = await services.property.getPropertyActionLogsService(id)
      if (res.data.status === true) {
        setPropertyLogs(res.data.data)
      }
    }
    catch (err) {
      console.log(err)
    }
  }

  const { toPDF, targetRef } = usePDF({
    filename: "property-logs.pdf",
    page: { margin: Margin.MEDIUM, format: "letter" },
    canvas: {
      mimeType: "image/png",
      qualityRatio: 1,
    }
  });

  const POINT_OF_SALE = {
    Banquet_Lawn: 1,
    Restaurant: 1,
    Bar: 1,
    Roof_Top: 1,
    Conference_Room: 1
  }

  const travel_choises = {
    1: 'Short-Stays',
    2: 'Corporate Deal',
    3: 'Family Vacation',
    4: 'Guaranteed Check-In',
    5: 'Group Check-In',
    6: 'Solo Traveler',
    15: 'Pet Friendly',
    16: 'Pay at Hotel'
  }

  const rejectReasonData = [
    "Property Details Incorrect/Incomplete",
    "Property Images Incorrect/Mismatch",
    "Owner Details Incorrect/Incomplete",
    "Legal Entity Details Incorrect/Incomplete",
    "Bank Details Incorrect/Incomplete"
  ]

  const [rejectReason, setRejectReason] = useState('');

  const travel_choises_index = propertyData?.travellerChoice?.split(',')


  const approveProperty = async (e) => {
    e.preventDefault();
    await changeStatus(1);
    await createPropertyActionLogs('Property Approved', propertyData?.id);
    setReason('')
    setShowApprovalPopup(false)
  }

  const [showRoomPopup, setShowRoomPopup] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({})
  const [editingRoomId, setEditingRoomId] = useState(null);

  const handleCreateRoom = async (data) => {
    const payload = {
      propertyId: selectedCategory?.propertyId,
      categoryId: selectedCategory?.categoryId,
      roomId: selectedCategory?.id,
      roomNumber: data.roomNum,
      floorNumber: data.floorNum,
      occupancy: data.occupancyNum
    }
    const isDuplicate = selectedCategory?.RoomDetails?.some((rD, i) => rD.roomNumber == payload?.roomNumber);
    if (isDuplicate) {
      toast.warn("Room Number can not be same!", {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      return;
    }
    const res = await services.property.createRoomService(payload)
    if (res.data.status == true) {
      toast.success(res.data.msg, {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
      getPropertyDetail(params.id);
      if (clickedButtonRef.current === "add") {
        setShowRoomPopup(true)
      } else if (clickedButtonRef.current === "save") {
        setShowRoomPopup(false)
      }
    }
  }

  const handleCheckRoomStatus = async (item) => {
    const payload = {
      propertyId: selectedCategory.propertyId,
      ids: [item.id]
    }
    const res = await services.property.checkRoomStatusService(payload)
    if (res?.data?.status == false) {
      toast.error(res?.data?.msg, {
        autoClose: 1000,
        pauseOnHover: true,
        position: "top-right",
      });
    }
    else {
      return res
    }
  }

  const editRoom = async (item) => {
    let xRes = await handleCheckRoomStatus(item)
    if (xRes?.data?.status == true) {
      setEditingRoomId(item.id)
      resetEditRoomForm({
        editFloor: item.floorNumber,
        editRooms: item.roomNumber,
        occupancy: item.occupancy,
      });
    }
  }

  const handleRoomEdit = async (data) => {
    let xRes = await handleCheckRoomStatus(data);
    if (xRes?.data?.status === true) {
      const payload = {
        id: editingRoomId,
        floorNumber: data[`editFloor${editingRoomId}`],
        roomNumber: data[`editRooms${editingRoomId}`],
        occupancy: data[`occupancy${editingRoomId}`],
      };
      try {
        const res = await services.property.editRoomService(payload);
        if (res.data.status) {
          toast.success(res.data.msg, { autoClose: 1000 });
          setEditingRoomId(null);
          getPropertyDetail(params.id);
        }
      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleDeleteRoom = async (item) => {
    let xRes = await handleCheckRoomStatus(item)
    if (xRes?.data?.status == true) {
      const confirmDelete = window.confirm("Are you sure you want to delete this room?");
      if (!confirmDelete) return;
      const res = await services.property.removeRoomService(item?.id)
      if (res?.data?.status == true) {
        toast.success(res?.data?.msg, {
          autoClose: 1000,
          pauseOnHover: true,
          position: "top-right",
        });
        getPropertyDetail(params.id);
      }
    }
  }

  const [activeDropdown, setActiveDropdown] = useState(null);
  const toggleDropdown = (id) => {
    setActiveDropdown((prev) => (prev === id ? null : id));
  };

  const finelCategory = categoryData.filter((category) =>
    !propertyData?.Rooms?.some((room) => room.categoryId === category.id)
  );

  useEffect(() => {
    document.body.classList.add('body-property-details');

    return () => {
      document.body.classList.remove('body-property-details');
    };
  }, []);

  return (
    <Layout title="Property Detail" withoutContainer>

      <div className="onboardDetails property-detail-page">
        <div className="wrap">
          <div className="head flex justify-content-between">
            <h5>Property Details</h5>
            <div className="flex gap-2">
              <Button
                type="button"
                className="btn-sm"
                onClick={() => fetchPropertyActionLogs(propertyData?.id)}
              >
                Logs
              </Button>
              <Button
                type="button"
                className="btn-sm"
                onClick={() => setShow(true)}
                disabled={propertyData?.Rooms?.length == propertyData?.onboardedRooms}
              >
                Create Room
              </Button>
              {
                (userDetail?.role === 1 || userDetail?.role === 2 || userDetail?.role === 9) &&
                (propertyData?.approved === 0 || propertyData?.approved === 1) && (
                  <Button
                    className="btn-sm bg-danger"
                    variant="danger"
                    onClick={() => {
                      setRejectModal(true);
                    }}
                  >
                    Reject
                  </Button>
                )}
              {
                (userDetail?.role === 1 || userDetail?.role === 2 || userDetail?.role === 9) &&
                (propertyData?.approved === 0 || (propertyData?.approved === 2 && propertyData.reSubmitted == 1)) && (
                  <Button
                    variant="primary"
                    className="btn-sm"
                    onClick={() => {
                      setShowApprovalPopup(true)
                    }}
                  >
                    Approve
                  </Button>
                )}

              <button type="button" className="btn btn-dark" onClick={() => setShowOwnerModal(true)}>Ownership Transfer</button>
            </div>
          </div>
          <div className="inner">
            <ul className="flex mt-3">
              <li>
                <h4>{propertyData.name}</h4>
                <span>Property Name</span>
              </li>
              <li>
                <h4>
                  {propertyData.latitude + "," + propertyData.longitude}
                </h4>
                <span>Lat Long</span>
              </li>
              <li>
                <h4>
                  {propertyData?.place_id}
                </h4>
                <span>Place Id</span>
              </li>
              <li>
                <h4>{(propertyData?.tanNumber && propertyData?.tanNumber != "undefined") ? propertyData?.tanNumber : 'N/A'}</h4>
                <span>TAN number</span>
              </li>
              <li>
                {categoryPropertyData.map((data, ind) => {
                  if (data.id === propertyData.propertyCategoryId) {
                    return <h4 key={ind}>{data.name}</h4>;
                  }
                })}
                <span>Category</span>
              </li>
              <li>
                <h4>
                  {(propertyData?.gstNumber && propertyData?.gstNumber !== "undefined") ? propertyData.gstNumber : 'N/A'}
                </h4>
                <span>GST number</span>
              </li>
              <li>
                <h4>{propertyData.propertyMobileNumber}</h4>
                <span>Mobile Number</span>
              </li>
              <li>
                <h4>{propertyData?.propertyEmailId}</h4>
                <span>Email</span>
              </li>
              <li>
                <h4>
                  {propertyData?.hub?.hubname}
                </h4>
                <span>Hub</span>
              </li>
              <li>
                <h4>
                  {
                    propertyData?.city ? propertyData?.city[0]?.name : "N/A"
                  }
                </h4>
                <span>City</span>
              </li>
              <li>
                <h4>{propertyData?.zone?.name}</h4>
                <span>Zone</span>
              </li>
              <li>
                <h4>
                  {propertyData?.state?.name ||
                    (Array.isArray(propertyData?.state) && propertyData?.state[0]?.name) ||
                    "N/A"}
                </h4>

                <span>State</span>
              </li>
              <li>
                <h4>{propertyData?.pincode}</h4>
                <span>Pincode</span>
              </li>
              <li>
                <h4>{propertyData?.landmark}</h4>
                <span>Landmark</span>
              </li>
              <li>
                <h4>{propertyData?.locality}</h4>
                <span>Locality</span>
              </li>
              <li>
                <h4>
                  {(propertyData?.PropertyPanNumber && propertyData?.PropertyPanNumber !== "undefined") ? propertyData.PropertyPanNumber : 'N/A'}
                </h4>
                <span>Property Pan Number</span>
              </li>
              <li>
                <h4>{propertyData?.noOfRooms}</h4>
                <span>Total Rooms</span>
              </li>
              <li>
                <h4>{propertyData?.onboardedRooms}</h4>
                <span>Signed Rooms</span>
              </li>
              <li>
                <h4>{propertyData.roomsCommission}</h4>
                <span>RRooms Take</span>
              </li>
              {propertyData.PropertyPanCertificate ? (
                <li>
                  <h4>
                    <a
                      href={`${baseImgUrl}/${propertyData.PropertyPanCertificate}`}
                      target="_blank"
                    >
                      {propertyData.PropertyPanCertificate}
                    </a>
                  </h4>
                  <span>Property Pan Certificate</span>
                </li>
              ) : null}
              {propertyData.tanCertificate ? (
                <li>
                  <h4>
                    <a
                      href={`${baseImgUrl}/${propertyData.tanCertificate}`}
                      target="_blank"
                    >
                      {propertyData.tanCertificate}
                    </a>
                  </h4>
                  <span>Tan Certificate</span>
                </li>
              ) : null}
              {propertyData.gstCertificate ? (
                <li>
                  <h4>
                    <a
                      href={`${baseImgUrl}/${propertyData.gstCertificate}`}
                      target="_blank"
                    >
                      {propertyData.gstCertificate}
                    </a>
                  </h4>
                  <span>GST Certificate</span>
                </li>
              ) : null}
              {propertyData.rentAgreement ? (
                <li>
                  <h4>
                    <a
                      href={`${baseImgUrl}/${propertyData.rentAgreement}`}
                      target="_blank"
                    >
                      {propertyData.rentAgreement}
                    </a>
                  </h4>
                  <span>Rent Agreement</span>
                </li>
              ) : null}
              {propertyData?.cancelCheque ? (
                <li>
                  <h4>
                    <a
                      href={`${baseImgUrl}/${propertyData.cancelCheque}`}
                      target="_blank"
                    >
                      {propertyData.cancelCheque}
                    </a>
                  </h4>
                  <span>Cancel Cheque</span>
                </li>
              ) : null}
              <li>
                <h4>{propertyData.address}</h4>
                <span>Property address</span>
              </li>
              <li>
                <ol className="pl-3 pb-2">
                  {propertyData?.haveBanquateLawan == POINT_OF_SALE.Banquet_Lawn && <li>Banquate/Lawan</li>}
                  {propertyData?.haveRestaurent == POINT_OF_SALE.Restaurant && <li>Restaurant</li>}
                  {propertyData?.haveBar == POINT_OF_SALE.Bar && <li>Bar</li>}
                  {propertyData?.haveRoofTop == POINT_OF_SALE.Roof_Top && <li>Roof Top</li>}
                  {propertyData?.haveConferenceRoom == POINT_OF_SALE.Conference_Room && <li>Conference Room</li>}
                </ol>
                <span>Points of sale</span>
              </li>
              <li>
                <h4>{(propertyData?.firmType && propertyData?.firmType != "undefined") ? propertyData?.firmType : "N/A"}</h4>
                <span>Firm Type</span>
              </li>
              <li>
                <h4>{(propertyData?.legalName && propertyData?.legalName != "undefined" && propertyData?.legalName != "null") ? propertyData?.legalName : "N/A"}</h4>
                <span>Legal Entity Name</span>
              </li>
              <li className="full">
                <ol className="pl-3 pb-2">
                  {showPolicy.filter(item => item !== '' && item !== null && item !== undefined).map((item, ind) => (
                    <li>{isNaN(item) ? item : propertyPolicy[item]}</li>
                  ))}
                </ol>
                <span>Hotel Policy</span>
              </li>
              <li className="full">
                <ol className="pl-3 pb-2">
                  {travel_choises_index?.length > 0 ?
                    travel_choises_index?.map((item) => {
                      return <li>{travel_choises[item]}</li>
                    }) : '-'
                  }
                </ol>
                <span>Traveller Choice</span>
              </li>
              <li className="full">
                <h4>{propertyData.propertyDescription}</h4>
                <span>Description</span>
              </li>
              <li className="full flex justify-content-between">
                <h4>Property Images</h4>
                <button onClick={() => setShowImagesPopup(true)} className="mr-3 btn- btn-primary">
                  Click To show Images
                </button>
              </li>
              <li className="full">
                <span>Property Amenities</span>
                <ul className="flex amenities">
                  {propertyData.PropertyAmenities
                    ? amenitiesRender("property").map((data, ind) => (
                      <li className="flex" key={ind}>
                        <img alt="" src={`${baseImgUrl}${data.icon}`} />
                        <p>{data?.name}</p>
                      </li>
                    ))
                    : null}
                </ul>
              </li>
            </ul>
            <h3>Owner Details</h3>
            <div className="row">

              <ul className="flex">
                <li>
                  <h4>
                    {propertyData.ownerFirstName +
                      " " +
                      propertyData.ownerLastName}
                  </h4>
                  <span>Full name</span>
                </li>
                <li>
                  <h4>{propertyData.ownerPan}</h4>
                  <span>Pan number</span>
                </li>
                <li>
                  <h4>{propertyData.ownerAdhar}</h4>
                  <span>Adhar number</span>
                </li>
                <li>
                  <h4>{propertyData.ownerMobile}</h4>
                  <span>Contact Number</span>
                </li>
                <li>
                  <h4>
                    <a href={`mailto:${propertyData.ownerEmail}`}>
                      {propertyData.ownerEmail}
                    </a>
                  </h4>
                  <span>Email address</span>
                </li>
                {propertyData.owneradharCertificate ? (
                  <li>
                    <h4>
                      <a
                        href={`${baseImgUrl}/${propertyData.owneradharCertificate}`}
                        target="_blank"
                      >
                        {propertyData.owneradharCertificate}
                      </a>
                    </h4>
                    <span>Owner Adhar Certificate</span>
                  </li>
                ) : null}
                {propertyData.ownerpanCertificate ? (
                  <li>
                    <h4>
                      <a
                        href={`${baseImgUrl}/${propertyData.ownerpanCertificate}`}
                        target="_blank"
                      >
                        {propertyData.ownerpanCertificate}
                      </a>
                    </h4>
                    <span>Owner Pan Certificate</span>
                  </li>
                ) : null}
              </ul>
            </div>
            <h3>Bank Details</h3>
            <div className="row">

              <ul className="flex">
                <li>
                  <h4>{bankDetails?.BankHolder ?? "N/A"}</h4>
                  <span>Bank Holder</span>
                </li>
                <li>
                  <h4>{bankDetails?.BankName ?? "N/A"}</h4>
                  <span>Bank Name</span>
                </li>
                <li>
                  <h4>{bankDetails?.BranchName ?? "N/A"}</h4>
                  <span>Branch Name</span>
                </li>
                <li>
                  <h4>{bankDetails?.BankAccountNumber ?? "N/A"}</h4>
                  <span>Bank Account Number</span>
                </li>
                <li>
                  <h4>{bankDetails?.BankIFSCCode ?? "N/A"}</h4>
                  <span>Bank IFSC code</span>
                </li>
              </ul>
            </div>


            <div className="row">
              <div className="table-box">
                <table>
                  <thead>
                    <tr>
                      <th>Category</th>
                      <th>Room Description</th>
                      <th>Regular Price</th>
                      <th>Total Room</th>
                      <th>ACTION</th>
                    </tr>
                  </thead>
                  <tbody>
                    {propertyData.Rooms &&
                      propertyData.Rooms.map((data, key) => (
                        <tr key={key}>
                          <td data-label="Category">
                            {categoryData.map((innerData) => {
                              if (innerData.id === data.categoryId) {
                                return innerData.name;
                              }
                            })}
                          </td>
                          <td data-label="Room Description">
                            <p>
                              {data?.roomDescription?.length > 100
                                ? data?.roomDescription?.substring(0, 100) +
                                "...."
                                : data?.roomDescription}
                            </p>
                          </td>
                          <td data-label="Regular Price">₹ {data.regularPrice}</td>
                          <td data-label="Total Room">{data?.RoomDetails?.length}</td>
                          <td data-label="ACTION">
                            <div className="custom-dropdown">
                              <Button variant="primary" className="btn-sm" onClick={() => toggleDropdown(data.id)}>
                                <i className="fa fa-pencil" aria-hidden="true"></i>
                              </Button>
                              {activeDropdown === data.id && (
                                <div className="custom-dropdown-menu">
                                  <ul>
                                    <button
                                      className="btn p-0 m-0 position-absolute end-0 p-2 top-0"
                                      onClick={() => toggleDropdown('')}
                                    >
                                      <FontAwesomeIcon
                                        icon="fa-solid fa-circle-xmark"
                                        size="xl"
                                      />
                                    </button>
                                    <li>
                                      <span onClick={() => {
                                        editHandler(data);
                                        toggleDropdown('')
                                      }}>Edit Category</span>
                                    </li>
                                    <li>
                                      <span onClick={() => {
                                        setShowRoomPopup(true)
                                        setSelectedCategory(data);
                                        toggleDropdown('')
                                      }}>Edit Room</span>
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>


      <OwnerShipModal propertyName={propertyData?.name} propertyId={propertyData?.id} show={showOwnerModal} setShowOwnerModal={setShowOwnerModal} userDetail={userDetail} />


      <Modal size="lg" show={showLogs} onHide={() => setShowLogs(false)}>
        <Modal.Header closeButton>
          <h5 className="mb-0">Property Logs Report</h5>
        </Modal.Header>
        <Modal.Body className="p-3">
          <div>
            <div style={{ maxHeight: '390px', overflowX: 'hidden', overflowY: 'auto' }} className="mb-3">
              <table ref={targetRef} className="table-hover common-table table-no-fixed-width">
                <thead>
                  <tr>
                    <th>Action By</th>
                    <th>Action</th>
                    <th>Remark</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    propertyLogs?.map((item) => {
                      let parcedData = JSON.parse(item?.data)
                      return (
                        <tr key={item?.logId}>
                          <td>{parcedData?.name}</td>
                          <td>{item?.action}</td>
                          <td>{item?.remark ? item?.remark : '-'}</td>
                          <td>{new Date(item?.createdAt).toLocaleString()}</td>
                        </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
          </div>
          <div className="text-center">
            <button type="button" className="btn btn-primary btn-sm" onClick={toPDF}>Print</button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show}
        onHide={() => {
          onPopupHide()
        }}
        size="xl"
        backdrop="static"
        className="modal_add_property"
      >
        <Modal.Header>
          <Modal.Title>{editMode ? "Update Room" : "Create Room"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm popup-create-room"
            onSubmit={handleSubmit(onSubmit)}
          >
            <Row>
              <Col xs={6} className="form-group">
                <label>Category</label>
                <select register={register} {...register("category")} disabled={editMode}>
                  <option disabled selected value="">
                    Select room category
                  </option>
                  {(editMode ? categoryData : finelCategory).map((innerData, key) => (
                    <option key={key} value={innerData?.id}>
                      {innerData?.name}
                    </option>
                  ))}
                </select>
                {errors?.category?.message && (
                  <div className="error-text">
                    <img alt="" src={AlertIcon} />
                    <span>
                      <ErrorMessage errors={errors} name={"category"} />
                    </span>
                  </div>
                )}
              </Col>
              <Col xs={6} className="form-group">
                <InputField
                  htmlFor="regularPrice"
                  text="Regular Price"
                  type="number"
                  placeholder="Enter Regular Price"
                  field={"regularPrice"}
                  register={register}
                  errors={errors}
                />
                {errors?.regularPrice?.message && (
                  <div className="error-text">
                    <img alt="" src={AlertIcon} />
                    <span>
                      <ErrorMessage errors={errors} name={"regularPrice"} />
                    </span>
                  </div>
                )}
              </Col>
              {
                propertyData?.allowHourly && category == 1 ? (
                  <>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="threeHrPrice"
                        text="3Hrs Regular Price"
                        type="number"
                        placeholder="Enter 3 Hrs Regular Price"
                        field={"threeHrPrice"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.threeHrPrice?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"threeHrPrice"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="sixHrPrice"
                        text="6Hrs Regular Price"
                        type="number"
                        placeholder="Enter 6 Hrs Regular Price"
                        field={"sixHrPrice"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.sixHrPrice?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"sixHrPrice"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="nineHrPrice"
                        text="9Hrs Regular Price"
                        type="number"
                        placeholder="Enter 9 Hrs Regular Price"
                        field={"nineHrPrice"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.nineHrPrice?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"nineHrPrice"} />
                          </span>
                        </div>
                      )}
                    </Col>
                  </>
                ) : null
              }

              {/* <Col xs={12} className="form-group">
                <label>
                  Room Description{" "}
                </label>
                <textarea
                  register={register}
                  {...register("roomDescription")}
                  placeholder={"Enter property description"}
                  readOnly
                ></textarea>
                {errors?.roomDescription?.message && (
                  <div className="error-text">
                    <img alt="" src={AlertIcon} />
                    <span>
                      <ErrorMessage
                        errors={errors}
                        name={"roomDescription"}
                      />
                    </span>
                  </div>
                )}
              </Col> */}
              <Col xs={12}>
                <div className="form-group full">
                  <label>Amenities</label>
                  <ul className="flex">
                    {amenitiesData.filter((data) => data.type == "room").map((c, i) => (
                      <li key={i}>
                        <input
                          type="checkbox"
                          id={c?.id}
                          value={c?.id}
                          {...register("amenities", {
                            onChange: (e) => changeHandler(e, c),
                          })}
                          checked={selectedAminites.includes(Number(c.id))}
                        />
                        <label
                          for={c?.id}
                          className={
                            selectedAminites.includes(c.id)
                              ? `activeLable`
                              : ""
                          }
                        >
                          {c?.name}
                        </label>
                      </li>
                    ))}
                  </ul>
                  {errors?.amenities?.message && (
                    <div className="error-text">
                      <img alt="" src={AlertIcon} />
                      <span>Please Select Amenities*</span>
                    </div>
                  )}
                </div>
              </Col>

              <Col>
                <ImageUploadBox
                  activeImageState={activeImageState}
                  setProfileImg={setProfileImg}
                  profileImgId={profileImg}
                  imageHandler={imageHandler}
                  selectedImages={imageSet}
                  deleteHandler={deleteImageHandler}
                  accept="image/*"
                />
              </Col>
              {editMode ? (
                <Col xs={12}>
                  <button
                    type="button"
                    className={`btn ${activeImageState ? "btn-success" : "btn-danger"
                      }`}
                    style={{
                      padding: 3,
                      fontSize: ".85rem",
                      marginTop: -20,
                    }}
                    onClick={() => setActiveImageState(!activeImageState)}
                  >
                    Choose Profile Image
                  </button>
                </Col>
              ) : null}

              <Col xs={12} className="form-group text-right">
                <Button variant="primary" type="submit" className="mr-2">
                  Submit
                </Button>
                <Button variant="secondary" type="button" onClick={() => {
                  setShow(false)
                  setEditMode(false)
                  onPopupHide()
                }}>
                  Cancel
                </Button>
              </Col>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="xl"
        show={showRoomPopup}
        onHide={() => {
          setShowRoomPopup(false)
        }}
      >
        <Modal.Header>
          <h5 className="text-white mb-0">Update Room</h5>
        </Modal.Header>
        <Modal.Body className="popup-update-room">
          <Row>
            {
              selectedCategory?.RoomDetails?.length > 0 ?
                <>
                  <div className="table-layout">
                    <div className="table-row head">
                      <span className="column">Floor</span>
                      <span className="column">Room No</span>
                      <span className="column">Occupancy</span>
                      <span className="column">Actions</span>
                    </div>
                    {
                      selectedCategory?.RoomDetails?.map((item) => {
                        const isEditing = editingRoomId === item.id;
                        return (
                          <form
                            key={item.id}
                            className={`table-row ${isEditing ? 'edit-mode' : ''}`}
                            onSubmit={handleSubmitEditRoom(handleRoomEdit)}>
                            <span className="column">
                              <select
                                defaultValue={item.floorNumber}
                                disabled={!isEditing}
                                {...registerEditRoom(`editFloor${item.id}`)}
                              >
                                {[...Array(10)].map((_, i) => (
                                  <option key={i} value={i + 1}>{i + 1}</option>
                                ))}
                              </select>
                            </span>
                            <span className="column">
                              <input
                                type="text"
                                defaultValue={item.roomNumber}
                                {...registerEditRoom(`editRooms${item.id}`)}
                                disabled={!isEditing}
                              />
                            </span>
                            <span className="column">
                              <select
                                defaultValue={item.occupancy}
                                {...registerEditRoom(`occupancy${item.id}`)}
                                disabled={!isEditing}
                              >
                                {
                                  ADULT_CHILD_RADIO_GROUP.map(({ label, value }) => (
                                    <option key={value} value={value}>{label}</option>
                                  ))
                                }
                              </select>
                            </span>
                            <span className="column">
                              {
                                isEditing ? (
                                  <button
                                    type="submit"
                                    className="btn-icon primary w-auto pl-2 pr-2"

                                  >
                                    Save
                                  </button>
                                ) : (
                                  <span
                                    className="btn-icon primary"
                                    onClick={() => editRoom(item)}
                                  >
                                    <MdOutlineModeEdit size={14} />
                                  </span>
                                )
                              }
                              <span
                                className="btn-icon danger ml-2"
                                onClick={() => handleDeleteRoom(item)}
                              >
                                <FaRegTrashAlt size={12} />
                              </span>
                            </span>
                          </form>
                        )
                      })
                    }
                  </div>
                  <div className="col-lg-12 mt-4 mb-4"></div>
                </> : ''
            }
          </Row>
          <form className="row" onSubmit={handleSubmitCreateRoom(handleCreateRoom)}>
            <Col lg={4} className="form-group">
              <label>Floor Number</label>
              <select
                className="form-control"
                {...registerCreateRoom(`floorNum`)}>
                {
                  Array.from({ length: 10 }).map((item, i) => {
                    return (
                      <option value={i + 1}>{i + 1}</option>
                    )
                  })
                }
              </select>
            </Col>
            <Col lg={4} className="form-group">
              <label>Room Number</label>
              <input
                type="number"
                className="form-control"
                {...registerCreateRoom(`roomNum`, { required: "Room number is required" })}
                placeholder="Room Number"
              />
              {errorsCreate?.roomNum && <p className="text-danger fs-8">{errorsCreate.roomNum.message}</p>}
            </Col>
            <Col lg={3} className="form-group">
              <label>Occupacny</label>
              <select
                className="form-control"
                {...registerCreateRoom(`occupancyNum`)}>
                {
                  ADULT_CHILD_RADIO_GROUP.map(({ label, value }) => {
                    return (
                      <option value={value}>{label}</option>
                    )
                  })
                }
              </select>
            </Col>
            <Col lg={1} className="form-group">
              <label style={{ opacity: '0' }}>Occupacny</label>
              <div>
                <Button variant="primary" type="submit" className="mr-2" onClick={() => (clickedButtonRef.current = "add")}>
                  Add
                </Button>
              </div>
            </Col>
            <Col xs={12} className="form-group text-right pt-3">
              <Button variant="primary" type="submit" className="mr-2" onClick={() => (clickedButtonRef.current = "save")}>
                Save & Close
              </Button>
              <Button variant="secondary" type="button" onClick={() => setShowRoomPopup(false)}>
                Cancel
              </Button>
            </Col>
          </form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showImagesPopup}
        onHide={() => {
          setShowImagesPopup(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className="checkInModal menuCardShowFull"
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="color-black"
          >
            Property Images
          </Modal.Title>
          <button
            className="closeButton"
            onClick={() => setShowImagesPopup(false)}
          >
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="listCard">
            <div className="imageslider flex justify-content-center">
              <div className="width90 position-relative">
                <Slider {...settingsImgSlider}>
                  {(showImages?.length > 0
                    ? showImages
                    : propertyData?.PropertyImage
                  )?.map((item, ind) => {
                    const { image } = item;
                    return (
                      <div key={ind}>
                        <figure className="sliderImg fitImg">
                          {image ? (
                            <img
                              src={`${baseImgUrl}/${image}`}
                              alt="property Images"
                            />
                          ) : (
                            <img src={sliderImgOnly} alt="property Images" />
                          )}
                        </figure>
                      </div>
                    );
                  })}
                </Slider>
                <div className="category_images flex gap-1">
                  <button
                    style={{
                      borderColor: imgFilter !== 0 ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter(0)}
                  >
                    All
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "Facade" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("Facade")}
                  >
                    Facade
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "Lobby" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("Lobby")}
                  >
                    Lobby
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "DReception" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("DReception")}
                  >
                    Reception
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "Room" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("Room")}
                  >
                    Room
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "Washroom" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("Washroom")}
                  >
                    Washroom
                  </button>
                  <button
                    style={{
                      borderColor:
                        imgFilter !== "Others" ? "transparent" : "#fff",
                    }}
                    onClick={() => imgCategoryFilter("Others")}
                  >
                    Others
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={rejectModal}
        onHide={() => {
          setRejectModal(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className="checkInModal menuCardShowFull"
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="color-black"
          >
            Reject Property
          </Modal.Title>
          <button className="closeButton" onClick={() => setRejectModal(false)}>
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm"
            onSubmit={(e) => rejectWithReason(e)}
          >
            <Container>
              <Row>
                <Col className="pt-3 pb-4" xs={12}>
                  <select className="form-control" onChange={(e) => setRejectReason(e.target.value)}>
                    <option value="">Select Rejection Reason</option>
                    {
                      rejectReasonData?.map((item) => (
                        <option value={item}>{item}</option>
                      ))
                    }
                  </select>
                </Col>
                <Col className="form-group" xs={12}>
                  <label htmlFor="reason">Reason For Reject Property</label>
                  <textarea
                    value={reason}
                    placeholder={"Enter Reason For Reject Property"}
                    id="reason"
                    name="reason"
                    onChange={(e) => setReason(e.target.value)}
                  ></textarea>
                </Col>
                <Col className="flex justify-content-center ">
                  <Button type="submit">Reject Property</Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        show={showApprovalPopup}
        onHide={() => {
          setShowApprovalPopup(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        className="checkInModal menuCardShowFull"
      >
        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="color-black"
          >
            Approve Property
          </Modal.Title>
          <button className="closeButton" onClick={() => setShowApprovalPopup(false)}>
            X
          </button>
        </Modal.Header>
        <Modal.Body>
          <Form
            className="popup-form onboardForm"
            onSubmit={(e) => approveProperty(e)}
          >
            <Container>
              <Row>
                {/* <Col className="pt-3 pb-4" xs={12}>
                  <select className="form-control" onChange={(e) => setRejectReason(e.target.value)}>
                    <option value="">Select Rejection Reason</option>
                    {
                      rejectReasonData?.map((item) => (
                        <option value={item}>{item}</option>
                      ))
                    }
                  </select>
                </Col> */}
                <Col className="form-group" xs={12}>
                  <label htmlFor="reason">Remark</label>
                  <textarea
                    value={reason}
                    placeholder={"Enter Reason For Reject Property"}
                    id="reason"
                    name="reason"
                    onChange={(e) => setReason(e.target.value)}
                  ></textarea>
                </Col>
                <Col className="flex justify-content-center ">
                  <Button type="submit">Approve Property</Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default Property;
